// taken from https://github.schibsted.io/smp-distribution/hyperion/blob/8f8abe68648c8e5037b7ff2fc58ec837e1345e51/src/sites/vg/ads/preparePageOptions.ts#L14
const formatTagValue = (tag = '') => {
  const escaped = tag
    .trim()
    .toLowerCase()
    .replace(/["'=!+#*~;^()<>@:?%|,.[\]]/g, '')
    .replace(/&/g, 'and')
    .replace(/[-\s]+/g, '-')
    .replace(/å/g, 'aa')
    .replace(/ø/g, 'oe')
    .replace(/æ/g, 'ae');

  return `vg_${escaped}`;
};

export { formatTagValue };
